import { useContext } from 'react';
import _get from 'lodash/get';
import _toLower from 'lodash/toLower';

import { AuthContext } from 'context/AuthContext';

const INTERNAL_DOMAINS = ['returnrabbit.com', 'shipstation.com', 'auctane.com'];

export default function useIsInternalUser() {
  const { userData, isTestRetailer } = useContext(AuthContext);

  const email = _toLower(_get(userData, 'email', ''));
  const isInternalDomain = INTERNAL_DOMAINS.some(domain => {
    return email.endsWith(`@${domain}`);
  });

  return isInternalDomain || isTestRetailer;
}
